import gql from "graphql-tag";
export const createGraphqlAuthToken = gql`
  mutation CreateToken($username: String!, $password: String!) {
    createToken(password: $password, username: $username){
      token
    }
  }
`;
